module.exports = __webpack_public_path__ + "static/img/wap_signin_logo_yzcid.195494c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/wap_signin_logo_yzcid.png
// module id = BiP5
// module chunks = 1